/* eslint-disable no-unused-vars */
import React from 'react';
import style from './progress.module.scss';
import { LinearProgress } from '@mui/material';
import { Status } from 'store/types';
import { ProgressItem } from 'components/modal/progressModal';
import SuccessIcon from 'icons/success';
import WarningIcon from 'icons/warning';
import cx from 'classnames';

const getIcon = (status: Status, percent: number) => {
  switch (status) {
    case 'pending':
      return <span className={'font16'}>{`${percent}%`}</span>;
    case 'rejected':
      return <WarningIcon></WarningIcon>;
    case 'fulfilled':
      return <SuccessIcon></SuccessIcon>;
  }
};

const getColor = (status: Status) => {
  switch (status) {
    case 'pending':
    case 'fulfilled':
      return 'success';
    case 'rejected':
      return 'error';
  }
};

const getPercent = (status: Status, percent: number) => {
  switch (status) {
    case 'pending':
    case 'fulfilled':
      return percent;
    case 'rejected':
      return 100;
  }
};

export default function LinearProgressComponent({
  status,
  percent,
  description,
}: ProgressItem) {
  const _percent = getPercent(status, percent);

  return (
    <div className={cx(style.container, style[`status_${status}`])}>
      <div className={style.info}>
        <span className={style.description}>{description}</span>
        <div className={style.status}>{getIcon(status, _percent)}</div>
      </div>

      <div className={style.bar}>
        <div className={style.line}>
          <LinearProgress
            variant="determinate"
            value={_percent}
            color={getColor(status)}
          />
        </div>
        {status === 'rejected' ? (
          <div className={style.error}>Не удалось загрузить файл</div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}
